import type { ComponentType } from "react";
import type { LeftPanelId } from "../rails/railConfig";
import { EnvironmentPanel } from "./EnvironmentPanel";
import { GemEnvPanel } from "./GemEnvPanel";
import { BackgroundPanel } from "./BackgroundPanel";
import { SceneLooksPanel } from "./SceneLooksPanel";
import { ModelStagePanel } from "./ModelStagePanel";
import { GroundPanel } from "./GroundPanel";
import { PosesPanel } from "./PosesPanel";
import { ExportPanel } from "./ExportPanel";
import { AdvancedPanel } from "./AdvancedPanel";
import { VariationsGridPanel } from "./VariationsGridPanel";
import { PartsPanel } from "./PartsPanel";
import { BatchRendererPanel } from "./BatchRendererPanel";
import { OnBodyPanel } from "./OnBodyPanel";
import { EmbedPanel } from "./EmbedPanel";
import { BrandingPanel } from "./BrandingPanel";
import { MetalsPanel, GemsPanel, OtherMaterialsPanel } from "./MaterialCategoryPanel";

export { VariationsGridPanel };

// Key widened to include "variations" ahead of the rail wiring. Adding it to
// the left rail requires the foreign `railConfig.ts` (LeftPanelId union member +
// a LEFT_RAIL item); once that lands the panel is already registered here and
// LeftPanel renders it with no further change.
export const LEFT_PANELS: Record<LeftPanelId | "variations", ComponentType> = {
  metals: MetalsPanel,
  gems: GemsPanel,
  otherMaterials: OtherMaterialsPanel,
  parts: PartsPanel,
  environment: EnvironmentPanel,
  gemEnv: GemEnvPanel,
  background: BackgroundPanel,
  scene: SceneLooksPanel,
  modelStage: ModelStagePanel,
  ground: GroundPanel,
  poses: PosesPanel,
  export: ExportPanel,
  batchRenderer: BatchRendererPanel,
  onBody: OnBodyPanel,
  embed: EmbedPanel,
  branding: BrandingPanel,
  advanced: AdvancedPanel,
  variations: VariationsGridPanel,
};
